<main>
    <div class="max-w-screen-xl mx-auto px-4">
        <div id="main-content">
            <div class="wrapper">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</main>
